import React, { useState, useEffect } from "react";

export default function CodeChallenge() {
  
const questions = [ 
  {
    code: String.raw`print("Hello!")`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(n²)", D:"O(log n)" },
    answer: "A",
    explanation: "Just one print – constant time."
  },

  {
    code: String.raw`for i in range(n):
    print(i)`,
    question: "How many times does it print?",
    options: { A:"Once", B:"n times", C:"n² times", D:"log n times" },
    answer: "B",
    explanation: "Runs once per item → O(n)."
  },

  {
    code: String.raw`for i in range(n):
    for j in range(n):
        print(i, j)`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(n²)", D:"O(log n)" },
    answer: "C",
    explanation: "Double loop → n×n."
  },

  {
    code: String.raw`print(arr[4])`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(n²)", D:"O(log n)" },
    answer: "A",
    explanation: "Access by index is constant time."
  },

  {
    code: String.raw`for i in range(n):
    if arr[i] == 10:
        print("Found!")`,
    question: "Best vs Worst case time?",
    options: { A:"Both O(1)", B:"O(1) best, O(n) worst", C:"O(n²) best, O(1) worst", D:"Both O(n)" },
    answer: "B",
    explanation: "Best: found early → O(1). Worst: scan all → O(n)."
  },

  {
    code: String.raw`for i in range(10):
    print(i)`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(10)", D:"O(log n)" },
    answer: "A",
    explanation: "Fixed 10 iterations → O(1)."
  },

  {
    code: String.raw`for i in range(n):
    print(i)
for j in range(n):
    print(j)`,
    question: "What’s the time complexity?",
    options: { A:"O(n)", B:"O(2n)", C:"O(n²)", D:"O(log n)" },
    answer: "A",
    explanation: "Two separate O(n) loops → O(n)."
  },

  {
    code: String.raw`Binary search halves the list each time.`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(log n)", D:"O(n²)" },
    answer: "C",
    explanation: "Halves each step → logarithmic."
  },

  {
    code: String.raw`for i in range(n):
    for j in range(n):
        for k in range(n):
            print(i, j, k)`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(n²)", D:"O(n³)" },
    answer: "D",
    explanation: "Triple nested → O(n³)."
  },

  {
    code: String.raw`You double a number until it reaches n.`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(log n)", C:"O(n)", D:"O(n²)" },
    answer: "B",
    explanation: "Growth by doubling → log₂n steps."
  }
];


  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [typing, setTyping] = useState("");

  // Typewriter effect
  useEffect(() => {
    const text = questions[current].code;
    let i = 0;
    setTyping("");

    const interval = setInterval(() => {
      // setTyping(prev => prev + text.charAt(i));
      i++;
      setTyping(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, 30);

    return () => clearInterval(interval);
  }, [current]);

  const checkAnswer = (choice) => {
    const q = questions[current];

    if (choice === q.answer) {
      setScore(score + 1);
      setFeedback(`✅ Correct! ${q.explanation}`);
    } else {
      setFeedback(`❌ Oops! Correct answer: ${q.answer}) ${q.options[q.answer]}. ${q.explanation}`);
    }
  };

  const nextQuestion = () => {
    if (current + 1 < questions.length) {
      setCurrent(current + 1);
      setFeedback("");
    }
  };

  const restartGame = () => {
    setCurrent(0);
    setScore(0);
    setFeedback("");
  };

  const endScreen = current >= questions.length;

  // INLINE STYLES
  const styles = {
    body: {
      margin: 0,
      background: "radial-gradient(circle at center, #0d0d0d, #1a1a1a 80%)",
      height: "100%",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      fontFamily: "Courier New, monospace",
    },
    container: {
      textAlign: "center",
      width: "90%",
      maxWidth: "800px",
    },
    codeBox: {
      background: "#111",
      border: "2px solid #0ff",
      borderRadius: "12px",
      padding: "20px",
      textAlign: "left",
      color: "#00ffcc",
      whiteSpace: "pre-wrap",
      minHeight: "120px",
      boxShadow: "0 0 20px #0ff",
      marginBottom: "20px",
      whiteSpace: "pre-wrap",
      overflow: "visible",
      lineHeight: "1.4",
      letterSpacing: "0.5px",
      textShadow: "none"

    },
    button: {
      padding: "15px",
      borderRadius: "15px",
      border: "2px solid #fff",
      fontSize: "1.2em",
      cursor: "pointer",
      background: "none",
      transition: "0.3s",
      width: "100%",
      marginTop: "10px",
    },
    nextBtn: {
      marginTop: "20px",
      padding: "15px 30px",
      fontSize: "1.2em",
      backgroundColor: "#00e6ff",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
    },
  };

  if (endScreen) {
    return (
      <div style={styles.body}>
        <h1>You scored {score} / {questions.length}</h1>
        <button style={styles.nextBtn} onClick={restartGame}>Play Again 🔁</button>
      </div>
    );
  }

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h3  style={{ color:"orange"  }}  >⚡ Code & Choose Challenge</h3>

        <pre style={styles.codeBox}><code>{typing}</code></pre>


        <h2 style={{ color: "cyan" }}>{questions[current].question}</h2>

        <button style={{...styles.button, borderColor:"#00bfff", color:"#00bfff"}} onClick={() => checkAnswer("A")}>
          A) {questions[current].options.A}
        </button>

        <button style={{...styles.button, borderColor:"#ff69b4", color:"#ff69b4"}} onClick={() => checkAnswer("B")}>
          B) {questions[current].options.B}
        </button>

        <button style={{...styles.button, borderColor:"#00ff7f", color:"#00ff7f"}} onClick={() => checkAnswer("C")}>
          C) {questions[current].options.C}
        </button>

        <button style={{...styles.button, borderColor:"#ffff66", color:"#ffff66"}} onClick={() => checkAnswer("D")}>
          D) {questions[current].options.D}
        </button>

        <div style={{ marginTop:"20px", minHeight:"40px" }}>{feedback}</div>

        <div><button style={styles.nextBtn} onClick={nextQuestion}>Next ➡️</button></div>
      </div>
    </div>
  );
}
